import SongPeaks from './songPeaks';
import type { ISongPeaks } from './iSongPeaks';

export type { ISongPeaks };
export default SongPeaks;
